import * as React from 'react';
import { Button, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { compose, Dispatch } from 'redux';
import { withLocalization, LProps } from '../../utils/wrappers';
import { State } from '../../redux/state';
import actions, { bindActionCreators } from '../../redux/actions';
import { connect } from 'react-redux';
import { JoinErrors, makeJoinErrors } from '../../utils/forms';
import { ValidationErrors, Competition, UserRead, CompetitionConfig } from '../../userApi';

interface Props {
  join: (signupTeam?: string) => void;
  validationErrors: ValidationErrors;
  competition?: Competition;
  competitionConfig: CompetitionConfig;
  user?: UserRead;
  logout: () => void;
}

interface JoinState {
  errors: Partial<JoinErrors>;
  submitted: boolean;
  signupTeam: string;
}

const initialState: JoinState = {
  errors: {},
  submitted: false,
  signupTeam: ''
};

class Join extends React.Component<LProps<Props>, JoinState> {
  public state: JoinState = initialState;

  public componentWillReceiveProps(nextProps: LProps<Props>) {
    const { validationErrors, t } = this.props;
    if (nextProps.validationErrors !== validationErrors) {
      const errors = makeJoinErrors(nextProps.validationErrors, t);
      this.setState({ errors });
    }
  }

  private join() {
    const { competitionConfig } = this.props;
    const hasCustomTeams = Boolean(
      competitionConfig.customSignupTeamLabels &&
      competitionConfig.customSignupTeamLabels.length &&
      competitionConfig.customSignupTeamIds &&
      competitionConfig.customSignupTeamIds.length
    );
    if (hasCustomTeams && !this.state.signupTeam) {
      this.setState({ submitted: true });
      return;
    }
    this.props.join(hasCustomTeams ? this.state.signupTeam : undefined);
  }

  public onLogout = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    this.props.logout();
  }

  public render() {
    const { errors, signupTeam, submitted } = this.state;
    const { competition, user, competitionConfig, t } = this.props;
    const teamLabel = (competitionConfig && competitionConfig.teamLabel) || t('Team');
    const hasCustomTeams = Boolean(
      competitionConfig.customSignupTeamLabels &&
      competitionConfig.customSignupTeamLabels.length &&
      competitionConfig.customSignupTeamIds &&
      competitionConfig.customSignupTeamIds.length
    );
    const needsTeam = hasCustomTeams && !signupTeam && submitted;

    return (
      <div id="join_form">
        <p>
          {t('You haven\'t joined')}&nbsp;
          <b>{competition && (competition.description || competition.name)}</b>&nbsp;
          {t('competition yet')}
        </p>
        <p>
          {t('Do you want to join?')}
        </p>
        {hasCustomTeams &&
          <FormGroup>
            <Label for="join_form__team">{`Choose your ${teamLabel}`}</Label>
            <Input
              id="join_form__team"
              type="select"
              value={signupTeam}
              invalid={needsTeam}
              onChange={(e) => this.setState({ signupTeam: e.target.value })}
            >
              <option value="">{t('Select…')}</option>
              {competitionConfig.customSignupTeamLabels.map((label, index) => (
                <option
                  key={competitionConfig.customSignupTeamIds[index]}
                  value={competitionConfig.customSignupTeamIds[index]}
                >
                  {label}
                </option>
              ))}
            </Input>
            {needsTeam && <FormFeedback style={{ display: 'block' }}>{t('Please choose your Division')}</FormFeedback>}
          </FormGroup>
        }
        <p>
          {errors.join && <FormFeedback>{errors.join}</FormFeedback>}
        </p>
        <Button
          id="join_form__submit"
          color="primary"
          onClick={() => this.join()}
          style={{ width: '250px' }}
        >{t('Join')}</Button>
        <div style={{ margin: '5px 0px' }}>
          <span>{t('Aren\'t you')}&nbsp;{user && user.firstName}?</span>&nbsp;
          <a href="" onClick={this.onLogout}>{t('Log out')}</a>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: State, _props: Props) => ({
  validationErrors: state.joinVE,
  competition: state.competition,
  competitionConfig: (state.competition && state.competition.config) || {},
  user: state.user
});

const mapDispatchToProps = (dispatch: Dispatch, _props: Props) =>
  bindActionCreators({
    join: actions.join,
    logout: actions.logout
  }, dispatch);

export default compose(
  withLocalization('auth'),
  connect(mapStateToProps, mapDispatchToProps)
)(Join);
